import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/about-us4.jpg")